//
//


import { mapActions, mapGetters } from "vuex";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQAvatar from "@/components/Generics/AQAvatar/AQAvatar.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import FabricSearch from "@/components/q-fabric-search.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";

export default {
    name: "ShareFilterModal",
    components: {
        AQModal,
        AQInput,
        AQTooltip,
        AQAvatar,
        AQCheckbox,
        AQButton,
        FabricSearch,
        AQCard
    },
    props: {
        filterLink: { type: String, default: "" },
        filterId: { type: Number, default: null },
        filterName: { type: String, default: "" },
        pageType: { type: String, default: "" }
    },
    data() {
        return {
            opened: true,
            shareFilterTooltip: this.$t("reports.copyInfo"),
            usersList: [],
            isListEmpty: false,
            payload: {
                pageSize: 20,
                pageNumber: 0,
                searchValue: "",
                statuses: [],
                types: ["EXTERNAL", "PLATFORM"]
            },
            search: "",
            usersSelectedList: []
        };
    },
    computed: {
        ...mapGetters("reports", ["getSelectedProcessReports"]),
        ...mapGetters("main", ["getCurrentApplicationId"]),
        ...mapGetters("perspectiveBuilder", ["getPerspectiveId"]),
        share() {
            return { label: this.$t("reports.share"), disabled: true };
        },
        selectionsCounter() {
            let counter;
            if (this.usersSelectedList.length) {
                const userSelected = this.usersSelectedList > 1 ? 2 : 1;
                counter = this.$tc("reports.usersSelected", userSelected, { count: this.usersSelectedList.length });
            } else {
                counter = this.$t("reports.noUsersSelected");
            }
            this.shareBtnDisabledState();
            return counter;
        }

    },
    watch: {
        search: {
            handler(newValue) {
                if (newValue) {
                    const searchV = newValue.trim();
                    if (searchV && searchV.length > 2) {
                        this.searchData(searchV);
                    }
                } else if (this.payload.searchValue) {
                    this.searchData();
                }
            }
        }
    },
    created() {
        this.getUsersData();
    },
    methods: {
        ...mapActions("reports", ["getReportsFilterUsers", "sendShareFilterMail"]),
        actionsDlg($event) {
            if ($event === "primary") {
                const payload = {
                    perspectiveCase: this.pageType === "searchPerspectives",
                    perspectiveId: this.getPerspectiveId,
                    appId: this.getCurrentApplicationId,
                    filterSetup: {
                        filterId: this.filterId,
                        processDefinitionId: this.getSelectedProcessReports[this.pageType].id,
                        userIds: this.usersSelectedList,
                        pageType: this.pageType
                    }
                };
                this.sendShareFilterMail(payload).then(() => {
                    this.$toast.showNotify({
                        type: "success",
                        message: this.$t("reports.saveFilterMessage", { count: this.filterName })
                    });
                });
            }
            this.$emit("closeShareModal");
            this.opened = false;
            this.shareFilterTooltip = this.$t("reports.copyInfo");
        },
        shareBtnDisabledState() {
            this.share.disabled = !this.usersSelectedList.length;
        },
        setUserType(user) {
            let type;
            if (user.type === "TOAUTHUSR") {
                type = "systemExternalUser";
            } else if (user.type === "TSYS") {
                type = "systemInternalUser";
            } else {
                type = (user.realmId || user.type === "TSAMLUSR" || user.type === "TOPENIDUSR") ? "externalUser" : "userPlatform";
            }
            return type;
        },
        setCustomAvatar(item) {
            return (item.avatarPath || item.avatar) ? `/identity/tenants/users/image/${item.id}/s` : null;
        },
        copyLink() {
            navigator.clipboard
                .writeText(this.filterLink)
                .then(() => {
                    this.shareFilterTooltip = this.$t("reports.succesCopyFilter");
                })
                .catch(e => {
                    console.log("Error", e);
                });
        },
        resetCopyTooltip() {
            this.shareFilterTooltip = this.$t("reports.copyFilterInfo");
        },
        searchData(value) {
            this.payload.searchValue = value || "";
            this.payload.pageNumber = 0;
            this.payload.pageSize = 20;
            this.getUsersData();
        },
        getUsersData(loadMore) {
            if (loadMore) {
                this.payload.pageSize = 10;
                if (this.payload.pageNumber) {
                    this.payload.pageNumber += 1;
                } else {
                    this.payload.pageNumber = 2;
                }
            }
            this.getReportsFilterUsers(this.payload).then(
                data => {
                    const dataResponse = data.list;
                    this.usersList = loadMore ? [...this.usersList, ...dataResponse] : [...dataResponse];
                    this.totalNumberItems = data.totalCount;
                    this.isListEmpty = !(this.usersList && this.usersList.length);
                }
            );
        }
    }
};
